import { Tag as CssModulesTag, TagSize as CssModulesTagSize, TagVariant as CssModulesTagVariant, type TagProps } from '@sunwebgroup/uds-ui/tag'
import { styled } from 'styled-components'

/**
 * @deprecated This type alias is deprecated and exists only for backward compatibility. Please use types from '@sunwebgroup/uds-ui/tag' instead.
 */
export type TagSize = CssModulesTagSize

/**
 * @deprecated This type alias is deprecated and exists only for backward compatibility. Please use types from '@sunwebgroup/uds-ui/tag' instead.
 */
export type TagVariant = CssModulesTagVariant

/**
 * @deprecated This component is deprecated and exists only to provide backward compatibility for code that previously relied on styled-components. Please use the corresponding component from '@sunwebgroup/uds-ui/tag' instead.
 */
export default Object.assign(
  styled(CssModulesTag)<TagProps>``,
  { displayName: 'Tag' },
)
